<script lang="ts">
    import { FontAwesomeIcon } from "@fortawesome/svelte-fontawesome";
    
    import type {
        IconDefinition,
        SizeProp,
    } from "@fortawesome/fontawesome-svg-core";

    export let icon: IconDefinition;
    export let title = "";
    export let extraClass = "";
    export let color: string = "currentColor";
    export let size: SizeProp = "1x";
</script>

<FontAwesomeIcon
    {icon}
    class={extraClass}
    {title}
    style={`color: ${color};`}
    {size}
/>
